import { proxyCustomElement, HTMLElement, h, Fragment } from '@stencil/core/internal/client';
import { a as setDataTableCellIndicesOnSlotChange } from './cl-data-table.utils.js';
import { d as defineCustomElement$4 } from './cl-data-table-cell2.js';
import { d as defineCustomElement$3 } from './cl-tooltip2.js';
import { d as defineCustomElement$2 } from './cl-typography2.js';

const clDataTableRowCss = ":host(cl-data-table-row){background-color:var(--data-table-row-background);display:table-row;position:relative;transition:background-color var(--animation-duration-fast) ease-in-out}:host(cl-data-table-row) cl-data-table-cell:first-of-type{max-width:-moz-fit-content;max-width:fit-content;padding:0;width:0}@supports not (background: -webkit-named-image(i)){:host(cl-data-table-row) cl-data-table-cell:first-of-type::after{background-color:var(--data-table-indent-color);border-radius:var(--size-quarter);bottom:0;content:\"\";left:0;position:absolute;top:0;width:var(--border-width)}}@supports (background: -webkit-named-image(i)){:host(cl-data-table-row) cl-data-table-cell:first-of-type{border-left:var(--border-width) solid var(--data-table-indent-color)}}:host(cl-data-table-row) cl-data-table-cell:first-of-type ::slotted(*){padding:0 var(--spacing-1) 0 var(--spacing-3) !important}@supports not (background: -webkit-named-image(i)){:host(cl-data-table-row)::before{background-color:var(--data-table-border-color);border-radius:var(--size-quarter);bottom:0;content:\"\";height:var(--border-width);left:0;position:absolute;width:100%;}}@supports not (background: -webkit-named-image(i)){:host(cl-data-table-row)::after{background-color:var(--data-table-border-color-selected);border-radius:var(--size-quarter);bottom:0;content:\"\";height:var(--border-width);left:0;position:absolute;width:100%;left:-100%;transition:transform var(--animation-duration-fast) var(--animation-timing-easeinout)}}:host(cl-data-table-row[zebra=\"\"]),:host(cl-data-table-row[zebra=true]),:host(cl-data-table-row[zebra=\"1\"]){background-color:rgb(var(--color-neutral-100))}:host(cl-data-table-row:hover){background-color:var(--data-table-row-background-hover)}:host(cl-data-table-row[selected=\"\"]),:host(cl-data-table-row[selected=true]){--data-table-border-color:var(--data-table-border-color-selected)}:host(cl-data-table-row[selected=\"\"])::after,:host(cl-data-table-row[selected=true])::after{transform:translateX(100%)}";

const ClDataTableRow$1 = /*@__PURE__*/ proxyCustomElement(class ClDataTableRow extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.rowIndex = undefined;
    this.selected = false;
    this.zebra = false;
  }
  render() {
    return (h(Fragment, null, h("cl-data-table-cell", null, h("slot", { name: 'action' })), h("slot", { onSlotchange: setDataTableCellIndicesOnSlotChange })));
  }
  static get style() { return clDataTableRowCss; }
}, [1, "cl-data-table-row", {
    "rowIndex": [2, "row-index"],
    "selected": [516],
    "zebra": [520]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-data-table-row", "cl-data-table-cell", "cl-tooltip", "cl-typography"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-data-table-row":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDataTableRow$1);
      }
      break;
    case "cl-data-table-cell":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "cl-tooltip":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "cl-typography":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const ClDataTableRow = ClDataTableRow$1;
const defineCustomElement = defineCustomElement$1;

export { ClDataTableRow, defineCustomElement };

//# sourceMappingURL=cl-data-table-row.js.map